import { render, staticRenderFns } from "./tip.vue?vue&type=template&id=3ed4a26d"
import script from "./tip.vue?vue&type=script&lang=ts"
export * from "./tip.vue?vue&type=script&lang=ts"
import style0 from "./tip.vue?vue&type=style&index=0&id=3ed4a26d&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports